/* eslint-disable @typescript-eslint/naming-convention */
// Reason: to set HTTP headers
import { Injectable } from '@angular/core';
import { ENVIRONMENT } from '../../../../environment/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ApiResponse, Pagination } from '../../models/api-response.model';
import { LastLearningCourseInterface } from '../../../features/home/models/home.model';
import { UpdateProgressInterface } from '../../models/webinar-course.model';
import {
    CertificateListingFilterInterface,
    CertificateListingInterface,
    ExportCertificateListingInterface,
    LinkedInAddToProfileInterface,
} from '../../../features/my-learning/my-learning.model';

@Injectable({
    providedIn: 'root',
})
export class LearningService {
    apiRoute = `${ENVIRONMENT.apiDomain}/api/v1/Learning`;

    constructor(private httpClient: HttpClient) {}

    public updateLearningProgress(body: UpdateProgressInterface): Observable<ApiResponse<boolean>> {
        return this.httpClient.post<ApiResponse<boolean>>(`${this.apiRoute}/update-progress`, body).pipe(
            map((response) => {
                return response as ApiResponse<boolean>;
            }),
        );
    }

    public completeLearning(id: string): Observable<ApiResponse<boolean>> {
        return this.httpClient.post<ApiResponse<boolean>>(`${this.apiRoute}/completed?programId=${id}`, null).pipe(
            map((response) => {
                return (response.result || {}) as ApiResponse<boolean>;
            }),
        );
    }

    public getLastCorseDetails(): Observable<ApiResponse<LastLearningCourseInterface>> {
        return this.httpClient.get<ApiResponse<LastLearningCourseInterface>>(`${this.apiRoute}/last`);
    }

    public getCertificateListing(
        body: CertificateListingFilterInterface,
    ): Observable<ApiResponse<Pagination<CertificateListingInterface[]>>> {
        return this.httpClient.post<ApiResponse<Pagination<CertificateListingInterface[]>>>(
            `${this.apiRoute}/hour`,
            body,
        );
    }

    // Returns the pre-filled LinkedIn "Add to profile" URL for a certificate.
    public addCertificateToLinkedIn(
        certificateId: number,
    ): Observable<ApiResponse<LinkedInAddToProfileInterface>> {
        return this.httpClient.post<ApiResponse<LinkedInAddToProfileInterface>>(
            `${this.apiRoute}/certificate/${certificateId}/linkedin`,
            null,
        );
    }

    public getBulkDownload(ids: number[]): Observable<HttpResponse<Blob>> {
        const body = { ids };

        return this.httpClient.post<Blob>(`${this.apiRoute}/bulk-download`, body, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            observe: 'response',
            responseType: 'blob' as 'json',
        });
    }

    public exportCertificate(filter: ExportCertificateListingInterface): Observable<HttpResponse<Blob>> {
        return this.httpClient.post<Blob>(`${this.apiRoute}/export`, filter, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            observe: 'response',
            responseType: 'blob' as 'json',
        });
    }

    public updateLearningProgressWithToken(
        body: UpdateProgressInterface,
        token: string,
    ): Observable<ApiResponse<boolean>> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

        return this.httpClient.post<ApiResponse<boolean>>(`${this.apiRoute}/update-progress`, body, { headers }).pipe(
            map((response) => {
                return response as ApiResponse<boolean>;
            }),
        );
    }
}
